export const homeCopy = {
  hero: {
    overline: '专业遗像制作',
    headline: '为家人，做一张可以长久摆放的照片',
    support:
      '从单人照或多人合影中选取目标人物，完成标准构图、背景处理与清晰度优化，输出庄重、可直接打印的遗像。',
    primary: '开始制作',
    secondary: '查看价格',
    trust: [
      '专注遗像制作，不是普通照片翻新',
      '照片不会提供给第三方作其他用途',
      '未付款 24 小时清理，已付款 7 天清理',
    ],
  },
  pricing: {
    overline: '制作档位',
    heading: '按处理复杂度分档，不按身份分档',
    sub: '两档的区别在于照片需要多少处理工作，与照片中的人是谁无关。',
    note:
      '价格以人民币展示。请通过闲鱼拍下对应商品并完成付款，再回站内填写闲鱼订单号，由管理员人工确认后解锁制作。',
    tiers: [
      {
        key: 'standard' as const,
        name: '标准制作',
        unit: '/ 张',
        blurb: '适合已经确定目标人物的单人照片。',
        includes: [
          '标准遗像构图',
          '背景统一为中性色',
          '清晰度与面部细节优化',
          '手机预览图与打印文件',
          '最多三个成功候选版本，包含首次',
        ],
      },
      {
        key: 'deep' as const,
        name: '深度制作',
        unit: '/ 张',
        blurb: '适合合影、需要补全肩部或调整服装的照片；合影须先选择一人。',
        includes: [
          '识别合影中的多个人像',
          '由用户选择目标人物',
          '提取目标人物并补全肩部与服装',
          '完成单人遗像构图与背景处理',
          '多尺寸打印文件',
          '最多三个成功候选版本，包含首次',
        ],
      },
    ],
  },
  principle: {
    overline: '我们的原则',
    statement: '先评估照片能否处理，再由家人核对与选择成品。',
    support:
      '上传后的基础检测不收费；不适合处理的照片会说明原因。AI 成品可能与本人存在差异，系统不进行身份相似度评分。请与原图核对，在最多三个成功候选版本中确认采用的一张。',
  },
  cases: {
    overline: '案例',
    heading: '看得见的处理过程',
    sub: '以下均为效果示意，用于说明处理方式与输出形式，不是真实客户的作品。',
    sampleLabel: '效果示意',
    beforeLabel: '处理前',
    afterLabel: '处理后',
    items: [
      {
        key: 'single',
        title: '生活照制作成标准遗像',
        desc: '从普通单人生活照出发，统一背景、人物位置和画面比例，制作成可直接打印的遗像。',
      },
      {
        key: 'group',
        title: '从多人合影中提取目标人物',
        desc: '识别合影中的多个人像，由用户选择其中一人，再提取并制作成独立遗像。',
      },
    ],
  },
  process: {
    overline: '制作流程',
    heading: '七步，每一步都让家人知道发生了什么',
    steps: [
      { n: '01', title: '注册登录', desc: '使用手机号、用户名或邮箱注册并登录后，才能选档下单。' },
      { n: '02', title: '选档下单', desc: '选择标准或深度制作，生成站内订单号。' },
      { n: '03', title: '闲鱼付款', desc: '打开对应档位的闲鱼商品链接，拍下并完成付款。' },
      { n: '04', title: '回填单号', desc: '将闲鱼订单号填回本站，等待人工核销。' },
      { n: '05', title: '管理员确认', desc: '确认收款后订单解锁，可进入创作室。' },
      { n: '06', title: '上传制作', desc: '上传照片并提交生成；可在候选版本中核对。' },
      { n: '07', title: '下载交付', desc: '确认采用版本后下载打印文件，请妥善保存。' },
    ],
  },
  privacy: {
    overline: '隐私承诺',
    heading: '照片只用于这一次遗像制作',
    items: [
      '照片不会提供给第三方作本次制作以外的任何用途',
      '不会用于广告、公开展示或模型训练',
      '未付款的照片与处理文件在 24 小时内清理',
      '已付款订单的照片、处理文件与成品在 7 天内清理',
      '清理期限内可以随时主动要求立即删除',
    ],
    link: '查看完整隐私说明',
  },
  faq: {
    overline: '常见问题',
    heading: '先回答几个最常被问到的',
    link: '查看更多（本页）',
    items: [
      {
        q: '如何付款？',
        a: '本站验证期通过闲鱼人工核销：拍下对应档位商品并付款后，回站内填写闲鱼订单号，管理员确认后即可制作。',
      },
      {
        q: '什么样的照片适合制作？',
        a: '人物清晰、面部完整、光线均匀的正面或近正面照最合适。手机翻拍的旧照片也可以。',
      },
      {
        q: '忘记密码怎么办？',
        a: '验证期不提供自助找回。请联系客服或管理员重置密码。',
      },
    ],
  },
};
